// Tạo một file mới là SurveyContext.js
import React, { createContext, useContext, useState } from "react";

const SurveyContext = createContext();

export const SurveyProvider = ({ children, ...props }) => {
	const [surveysId, setSurveysId] = useState(null);

	const childrenWithProps = React.Children.map(children, (element) =>
		React.cloneElement(element, props),
	);

	return (
		<SurveyContext.Provider value={{ surveysId, setSurveysId }}>
			{childrenWithProps}
		</SurveyContext.Provider>
	);
};

export const useSurveyContext = () => useContext(SurveyContext);
